<script setup lang="ts">
import { useMenu } from '@/composables/useMenu'
import SidebarItem from './components/SidebarItem.vue'

defineProps<{
  collapsed?: boolean
}>()

const { openKeys, selectedKeys, menuItems, handleOpenChange } = useMenu()
</script>

<template>
  <div class="sidebar-container" :class="{ 'is-collapsed': collapsed }">
    <!-- Logo -->
    <div class="sidebar-logo">
      <router-link to="/dashboard" class="logo-link" title="小嘿工作台">
        <img src="/logo.png" alt="小嘿工作台" class="logo-image" />
        <span v-if="!collapsed" class="logo-title">小嘿工作台</span>
      </router-link>
    </div>

    <!-- 菜单 -->
    <a-menu
      v-model:open-keys="openKeys"
      v-model:selected-keys="selectedKeys"
      mode="inline"
      class="sidebar-menu"
      @open-change="handleOpenChange"
    >
      <SidebarItem 
        v-for="item in menuItems" 
        :key="item.path" 
        :item="item" 
      />
    </a-menu>
  </div>
</template>

<style scoped lang="scss">
.sidebar-container {
  height: 100%;
  overflow: hidden auto;
  background: var(--card-bg);
}

.sidebar-logo {
  padding: 0 16px;
  
  .logo-link {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 56px;
    text-decoration: none;
    overflow: hidden;
    white-space: nowrap;
    
    .logo-image {
      height: 32px;
      width: 32px;
      object-fit: cover;
      object-position: left;
      flex: none;
      border-radius: 6px;
    }
  }
}

.logo-title { color: var(--text-color); font-size: 16px; font-weight: 600; }
.is-collapsed .sidebar-logo { padding: 0 16px; }

.sidebar-menu {
  padding: 12px 4px;
  background: transparent;
  border-right-color: transparent;
  border-inline-end: none !important;
}
</style>
